import type { ReactNode } from "react"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import type { UdsColor } from "@gatsby-plugin-generic-page/helpers/helTypographyToUds"
import Paragraph from "@gatsby-plugin-generic-page/markdown/components/Paragraph"
import { Text } from "@ionos-web-design-system/react"
import type { Components } from "react-markdown"
import ListItem from "./components/ListItem"

function getMarkdownOverrides(isLightText: boolean): Components {
  const color: UdsColor | undefined = isLightText ? "base" : undefined

  return {
    p: ({ children }: { children: ReactNode }) => (
      <Paragraph typography="medium1_h" pushSpace={1} color={color}>
        {children}
      </Paragraph>
    ),
    strong: ({ children }: { children: ReactNode }) => (
      <Text asChild variant="body" weight="bold" color={color}>
        <span>{children}</span>
      </Text>
    ),
    ul: ({ children }: { children: ReactNode }) => (
      <PushOrg topSpace={2} bottomSpace={2}>
        <ul
          className="list-none p-0 m-0"
          style={isLightText ? { color: "white" } : undefined}
        >
          {children}
        </ul>
      </PushOrg>
    ),
    ol: ({ children }: { children: ReactNode }) => (
      <PushOrg bottomSpace={2}>
        <ol style={isLightText ? { color: "white" } : undefined}>{children}</ol>
      </PushOrg>
    ),
    li: ({ children }: { children: ReactNode }) => (
      <ListItem color={color}>{children}</ListItem>
    ),
  } as Components
}

export default getMarkdownOverrides
